<template>
    <div>
        <div class="content-header">
            <PageTitleComponent title="Control de acceso"></PageTitleComponent>
        </div>

        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div style="height: 2100px">
                            <iframe :src="config.CLE + 'admin/events/' + evento_id + '/control-acceso?rm=1'" width="100%" style="height: 100%; border: none;" scrolling="no"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import PageTitleComponent from '@/components/backend/components/PageTitleComponent';
import { config } from '@/config.js';

export default {
    props: ['evento_id'],
    components: {
        PageTitleComponent
    }
}
</script>
